import { Section } from "../components/Section";
import FAQ from "../components/faq/FAQ";

export default function FAQPage() {
  return (
    <Section>
      <FAQ />
    </Section>
  );
}
